// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"5b3e6153","313":"5b3e6153","487":"bc3b7f0b","957":"5b3e6153"}[chunkId] + ".chunk.css";
};